import request from "@/utils/request";
import {formatBannerDataFromSever} from "@/views/System/Setting/Module/module-xml-manager";

/**
 * 获取模块列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
export function moduleList({userId}) {
    return request({url: `/appi/Index/GetIndexModule?uID=${userId}`})
}

/**
 * 删除模块
 * @param userId
 * @param moduleId
 * @returns {AxiosPromise}
 * @constructor
 */
export function moduleDelete({userId, moduleId}) {
    return request({url: `/appi/Setting/ModuleDelete?uId=${userId}&moduleId=${moduleId}`})
}

export function moduleDetail({userId, moduleId}) {
    return request({
        url: `/appi/Setting/moduleDetail?uId=${userId}&moduleId=${moduleId}`
    }).then(res => {
        res.data = formatBannerDataFromSever(res.data[0]);
        // res.datam = res.data[1];
        // console.log('a',res)
        return Promise.resolve(res);
    });
}


/**
 * 
 * Banner 保存/编辑
 * @returns {AxiosPromise}
 * @constructor
 */
export function moduleModify({userId, moduleId, moduleName,disOrder,url, img,isTab,isContent}) {
    return request({
        url: `/appi/Setting/ModuleModify`,
        data: {
            uID: userId,
            moduleId,
            moduleName,
            img,
            disOrder,
            isTab,
            url,
            isContent,

        }
    })
}


/////////////////////////////////////////Category
/**
 * 获取分类列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
export function categoryList({userId}) {
    return request({url: `/appi/Setting/categoryList?uID=${userId}`})
}


/**
 * 
 * Banner 保存/编辑
 * @returns {AxiosPromise}
 * @constructor
 */
export function categoryModify({userId, cateId, cateName,orderId}) {
    return request({
        url: `/appi/Setting/categoryModify`,
        data: {
            uID: userId,
            cateId,
            cateName,
            orderId,
        }
    })
}


/**
 * 删除分类
 * @param userId
 * @param moduleId
 * @returns {AxiosPromise}
 * @constructor
 */
export function categoryDelete({userId, cateId}) {
    return request({url: `/appi/Setting/categoryDelete?uId=${userId}&cateId=${cateId}`})
}

/**------------------------------------------------------------------------------------
     * 数据字典 获取列表
     * 原型图中缺少检索；类型下拉框接口见下一条
     * @param userId
     * @param typeCate
     * @param mediumIds
     * @param key
     * @returns {AxiosPromise}
     * @constructor
     */
    export function BaseDictionaryList({userId, typeCate = '全部', key = ''}) {
        return request({url: `/appi/Setting/BaseDictionaryList?uId=${userId}&typeCate=${typeCate}&key=${key}`})
    }

/**
 * 数据字典 获取列表页的类型检索下拉框
 * @param userId
 * @returns {AxiosPromise} orderId 排序号，typeCate类型
 * @constructor
 */
export function BaseDictionaryList_typeDDL({userId,}) {
    return request({url: `/appi/Setting/BaseDictionaryList_typeDDL?uId=${userId}`})
}


export function BaseDictionaryDelete({userId, dictId}) {
    return request({url: `/appi/Setting/BaseDictionaryDelete?uId=${userId}&dictId=${dictId}`})
}

/**
 * 数据字典 新增
 * @param userId
 * @param typeCate
 * @param xml *选项内容，格式为 <Item name="自营" remark="无"></Item><Item name="组合经营" remark="无"></Item>  name 为选项名称，remark 为说明
 * @returns {AxiosPromise}
 * @constructor
 */
export function BaseDictionaryNew({userId, dictType, xml = ''}) {
    return request({url: `/appi/Setting/BaseDictionaryNew`, data: {uId: userId, dictType, xml}})
}

/**
 * 数据字典 修改
 * @param userId
 * @param typeId *字典ID
 * @param typeCate *类型名称
 * @param typeName *选项内容
 * @param mediumIds
 * @param remark
 * @returns {AxiosPromise}
 * @constructor
 */
export function BaseDictionaryUpdate({userId, dictId, dictType, dictName}) {
    return request({
        url: `/appi/Setting/BaseDictionaryUpdate`,
        data: {uId: userId, dictId, dictType, dictName}
    })
}